module.exports = __webpack_public_path__ + "static/media/systemAnnouncement.4302d7bc.svg";